import _defineProperty from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import React, { useState, useEffect, useRef } from 'react';
import classNames from 'classnames';
import { useDeviceInfo } from '../../hooks/useDeviceInfo';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var ReadMore = function ReadMore(_ref) {
  var description = _ref.description,
      numberOfLines = _ref.numberOfLines;
  var serviceDescriptionRef = useRef(null);

  var _useState = useState(true),
      showReadMore = _useState[0],
      setReadMore = _useState[1];

  var _useState2 = useState(false),
      isFullText = _useState2[0],
      setFullText = _useState2[1];

  var _useState3 = useState(false),
      isSafari = _useState3[0],
      setIsSafari = _useState3[1];

  var deviceInfo = useDeviceInfo();
  var mobile = deviceInfo.mobile,
      tablet = deviceInfo.tablet,
      desktop = deviceInfo.desktop,
      narrowScreen = deviceInfo.narrowScreen,
      iPad = deviceInfo.iPad;
  useEffect(function () {
    setReadMore(true);
    setFullText(false);
  }, [mobile, tablet, desktop, narrowScreen, iPad]);
  useEffect(function () {
    var _serviceDescriptionRe = serviceDescriptionRef === null || serviceDescriptionRef === void 0 ? void 0 : serviceDescriptionRef.current,
        scrollHeight = _serviceDescriptionRe.scrollHeight;

    var _serviceDescriptionRe2 = serviceDescriptionRef === null || serviceDescriptionRef === void 0 ? void 0 : serviceDescriptionRef.current,
        offsetHeight = _serviceDescriptionRe2.offsetHeight; // Safari displays nothing when you clamp block-level child elements
    // this causes the Read more to break on safari browsers and chrome/firefox on iOS devices
    // Reference: https://stackoverflow.com/questions/57546280/clamping-lines-with-line-clamp-and-nested-p-tags#comment120047781_57547645


    var isAppleVendor = navigator.vendor && navigator.vendor.indexOf('Apple') > -1;
    var isSafariBrowser = isAppleVendor && navigator.userAgent && navigator.userAgent.indexOf('CriOS') === -1 && navigator.userAgent.indexOf('FxiOS') === -1;
    var isSafariWrapper = isAppleVendor && navigator.userAgent && (navigator.userAgent.indexOf('CriOS') > -1 || navigator.userAgent.indexOf('FxiOS') > -1);
    setIsSafari(isSafariBrowser || isSafariWrapper);

    if (offsetHeight === scrollHeight) {
      // element doesn't have overflow
      setFullText(true);
      setReadMore(false);
    }
  }, [isFullText]);

  var handleToggleReadMore = function handleToggleReadMore() {
    setReadMore(!showReadMore);
  };

  var lineClamp = "line-clamp-".concat(numberOfLines); // set height and overflow manually for Safari browsers and safari wrapped browsers

  var heightProp = {
    height: showReadMore ? "".concat(1.5 * numberOfLines + 0.5, "rem") : 'auto',
    overflow: showReadMore ? 'hidden' : 'visible'
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: classNames('leading-6 mb-6 relative', _defineProperty({}, lineClamp, showReadMore && !isSafari)),
      style: isSafari ? heightProp : {},
      ref: serviceDescriptionRef,
      children: [/*#__PURE__*/_jsx("div", {
        children: description
      }), /*#__PURE__*/_jsx("div", {
        className: classNames('bottom-0 absolute h-20 opacity-100 w-full', {
          block: showReadMore,
          hidden: !showReadMore
        }),
        style: {
          backgroundImage: 'linear-gradient(rgba(249, 250, 251, 0), rgba(249, 250, 251, 1))'
        }
      })]
    }), isFullText ? null : /*#__PURE__*/_jsxs("div", {
      children: [showReadMore && /*#__PURE__*/_jsx("a", {
        className: "clickable fw-500 text-subkit-primary mt-3",
        onClick: handleToggleReadMore,
        children: "Read more"
      }), !showReadMore && /*#__PURE__*/_jsx("a", {
        className: 'clickable fw-500 text-subkit-primary',
        onClick: handleToggleReadMore,
        children: "Read less"
      })]
    })]
  });
};